import { TrendingUp, TrendingDown, Receipt, Percent } from "lucide-react";

import { brl, pct } from "../lib/periodos";

import { CarregandoCards } from "@/components/carregando";


function Card({ icon: Icon, label, valor, hint, cor }) {
  return (
    <div className="rounded-xl border bg-card p-3 sm:p-4 min-w-0">
      <div className="flex items-center gap-2 mb-1.5">
        <Icon className={`w-4 h-4 ${cor || "text-muted-foreground"}`} />
        <p className="text-sm font-medium text-muted-foreground">{label}</p>
      </div>
      {/* Celular (25/10/2026): sem quebra — "-R$" ficava numa linha e o número na outra */}
      <p className={`text-lg min-[420px]:text-xl sm:text-2xl font-extrabold tabular-nums tracking-tight sm:tracking-normal whitespace-nowrap ${cor || ""}`}>{valor}</p>
      {hint && <p className="text-xs text-muted-foreground mt-0.5">{hint}</p>}
    </div>
  );
}

export default function CardsResumo({ resumo, loading }) {
  if (loading) {
    // Carregamento com cards (25/10/2026): a peça compartilhada do painel.
    return <CarregandoCards quantos={4} className="grid grid-cols-2 lg:grid-cols-4 gap-4" altura="h-[100px]" />;
  }
  const r = resumo || {};
  const lucro = Number(r.resultado_liquido || 0);
  const positivo = lucro >= 0;

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      <Card icon={Receipt} label="Receita Líquida" valor={brl(r.receita_liquida || 0)}
            hint={`${r.pedidos || 0} pedidos${r.taxas ? ` · taxas ${brl(r.taxas)}` : ""} · ticket ${brl(r.ticket_medio || 0)}`} />
      <Card icon={Percent} label="Margem Bruta" valor={pct(r.margem_bruta)}
            hint={`Lucro bruto ${brl(r.lucro_bruto || 0)}`} />
      <Card icon={TrendingDown} label="Despesas" valor={brl((r.cmv || 0) + (r.despesas_operacionais || 0))}
            hint={`CMV ${brl(r.cmv || 0)} + operacionais`} />
      <Card
        icon={positivo ? TrendingUp : TrendingDown}
        label="Resultado Líquido"
        valor={brl(lucro)}
        hint={`Margem ${pct(r.margem_liquida)}`}
        cor={positivo ? "text-emerald-600 dark:text-emerald-400" : "text-red-600 dark:text-red-400"}
      />
    </div>
  );
}
